module.exports = __webpack_public_path__ + "components/pages/UI/test2.jpg";